import React from 'react'
import Form from 'react-bootstrap/Form'
import '../../styles/Input/InputSwitch.css'

{/* 
<InputSwitch
    theme={'light | dark'}
    value={} setValue={}
    label={""}
/>
--inputTextLight: #ffffff;
--inputTextLightText: #49574b;
--inputTextDark: #eef5ef;
--inputSwitchLightText: #ffffff;
--inputSwitchDarkText: #555555;
--inputSwitchActive: #435e48;
--inputSwitchBorder: #00000040;
*/}

function InputSwitch({ value, setValue, label, theme }) {

    return (

        <div className={['inputSwitch', theme === 'light' ? 'inputSwitchLight' : 'inputSwitchDark'].join(" ")}>
            <Form>
                <Form.Check type="switch" checked={value} onChange={() => setValue(!value)} />
            </Form>
            <div className={['inputSwitchLabel', theme === 'light' ? 'inputSwitchLabelLight' : 'inputSwitchLabelDark'].join(" ")}>
                {label}
            </div>
        </div>

    )

}

export default InputSwitch